import { useCallback } from "react";
import { useAppDispatch } from "../../../../../hooks";
import { debounce } from "../../../../utils";
import { setIssueSortedColInRedux, updateColumnStateThunk } from "../../issueSlice";
import { useDragColumnChange } from "../../issueUtils";

export const useIssueTableColumnStateHandlers = () => {
  const dispatch = useAppDispatch();

  const handleColumnStateUpdate = useCallback(
    (event) => {
      const columnState =
        event.api.getAllDisplayedColumns()?.map((col, index) => ({
          colId: col.getColId(),
          orderPriority: index,
          width: col.getActualWidth(),
        })) ?? [];

      dispatch(updateColumnStateThunk(columnState));
    },
    [dispatch],
  );

  const debouncedHandleToggleColumnVisibility = useCallback(
    debounce((event) => {
      handleColumnStateUpdate(event);
    }, 1000),
    [handleColumnStateUpdate],
  );

  const onSortChanged = useCallback(
    (params) => {
      const updatedColumn = params.api.getColumnState().filter((state) => state.sort !== null)[0];
      const formattedColumn = updatedColumn
        ? { column: updatedColumn.colId, direction: updatedColumn.sort.toUpperCase() }
        : null;

      dispatch(setIssueSortedColInRedux(formattedColumn));
    },
    [dispatch],
  );

  const { onDragStarted, onDragStopped } = useDragColumnChange(handleColumnStateUpdate);

  const onColumnResized = useCallback(
    (event) => {
      if (event.finished !== true) return;
      handleColumnStateUpdate(event);
    },
    [handleColumnStateUpdate],
  );

  return {
    debouncedHandleToggleColumnVisibility,
    onColumnResized,
    onDragStarted,
    onDragStopped,
    onSortChanged,
  };
};
